import React, { useEffect, useRef, useState } from "react";
import * as L from "leaflet";
import "utils/leaflet.rotatedMarker";
import { TrackPoint } from "rx/tracksSlice";

export type NutiId = {
    type: string;
    id: string;
};
type ArrowMarkerProps = {
    className?: string;
    loc: TrackPoint;
    map: L.Map;
    color?: string;
    label?: string;
    title?: string;
    nutiid?: NutiId;
};

const markerOptions = (size: number, heading: number, color: string) => {
    return Object.assign(
        {
            icon: arrowIcon(size, color),
            rotationAngle: heading,
        },
    );
}
const arrowIcon = (size: number, color: string) => L.divIcon({
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    className: "mymarker",
    html: `<svg xmlns="http://www.w3.org/2000/svg" fill="${color}" viewBox="0 0 32 32"><path d="M 2,32 L 16,0 L 30,32 L 16,25 Z" stroke="black" stroke-width="2"/></svg>`,
});

const circleIcon = (size: number, color: string, border: string = "black") => L.divIcon({
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    className: "mymarker",
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="14" fill="${color}" stroke="${border}" stroke-width="2"/>
        </svg>`,
});

enum TrackingMarkerIcon {
    Arrow,
    Circle
}

const MOVING_SPEED = 2;
export const TeamMarker: React.FC<ArrowMarkerProps> = (props) => {
    const [marker, setMarker] = useState<L.Marker>();
    const iconTypeRef = useRef<TrackingMarkerIcon>(TrackingMarkerIcon.Arrow);


    useEffect(() => {
        const newmarker = L.marker(
            props.loc,
            markerOptions(25, props.loc.g + 0, props.color || "blue")
        );

        props.map.addLayer(newmarker);
        setMarker(newmarker);
        return () => {
            props.map.removeLayer(newmarker)
        }
        // We have different effects to actually update this data.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!marker) return;
        marker.setLatLng(props.loc);
        (marker.options as any).rotationAngle = props.loc.g;
        (marker as any)?.update();
        if (iconTypeRef.current !== TrackingMarkerIcon.Circle && props.loc.s < MOVING_SPEED) {
            marker.setIcon(circleIcon(15, props.color || "blue"));
            iconTypeRef.current = TrackingMarkerIcon.Circle
        } else if (iconTypeRef.current !== TrackingMarkerIcon.Arrow && props.loc.s >= MOVING_SPEED) {
            marker.setIcon(arrowIcon(25, props.color || "blue"));
            iconTypeRef.current = TrackingMarkerIcon.Arrow;
        }
    }, [props.loc, props.color, marker])

    useEffect(() => {
        if (!marker) return;
        if (props.label) {
            marker.bindTooltip(
                `<div style="color:${props.color || "blue"}">${props.label
                }</div>`,
                {
                    permanent: true,
                    offset: [10, -10],
                    className: "ArrowHeadTooltip",
                }
            );
            const iconElement = marker.getElement();
            if (iconElement) {
                iconElement.title = "";
            }
        } else {
            marker.unbindTooltip();
            if (props.title) {
                const iconElement = marker.getElement();
                if (iconElement) {
                    iconElement.title = props.title;
                }
            }
        }
    }, [marker, props.label, props.title, props.color])
    return null;
}

export default TeamMarker;